export const hasPrivilege = (user, section, privilege = null) => {
    if (!user || !Array.isArray(user.privileges)) return false;
  
    const privilegeObject = user.privileges.find(p => Object.hasOwn(p, section));
    if (!privilegeObject) return false;
  
    const sectionPrivileges = privilegeObject[section];
    if (!Array.isArray(sectionPrivileges)) return false;
  
    return privilege ? sectionPrivileges.includes(privilege) : sectionPrivileges.length > 0;
  };
  